import React from "react";
import PropTypes from "prop-types";

const DownArrowIcon = ({ color = "none" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DownArrowIcon.propTypes = {
  color: PropTypes.string,
};

export default DownArrowIcon;
